import { Injectable, ViewChild } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Subject } from "rxjs/internal/Subject";
import { Utils } from "src/app/_helpers/utils";
import { GuestReport } from './guest-report.model';
import { ChartComponent } from 'ng-apexcharts';
import { GuestReportRequest, RequestParameters } from './guest-report-request.model';
import { Subscription } from 'rxjs';
import { GuestReportViewModule } from './guest-report.module';
import { ChartOptions } from 'src/app/_helpers/chartOptions';

const url = environment.api

@Injectable({
  providedIn: GuestReportViewModule
})
export class GuestReportService {

  @ViewChild("chart") chart: ChartComponent;

  guestReport: GuestReport = new GuestReport();
  guestReports: GuestReport[];

  filterDetailsSubject: Subject<any> = new Subject<any>();
  filterDetailsShowLoader: boolean;

  enter: number[] = [];
  leave: number[] = [];
  date: string[] = [];
  
  public chartOptions: Partial<ChartOptions>;
  defaultLocale: string;
  chartHeader: string;
  chartHeaderSize: string;
  entires: string;
  exits: string;
  noDataText: string;

  request: GuestReportRequest = new GuestReportRequest;
  requestParameters: RequestParameters = new RequestParameters;

  public actualSubscription: Subscription = new Subscription();

  localePl = require("node_modules/apexcharts/dist/locales/pl.json");
  localeEn = require("node_modules/apexcharts/dist/locales/en.json");

  constructor(
    private http: HttpClient,
  ) { }

  reloadFilter() {
    this.filterDetailsSubject.next(null);
  }

  getGuestReports(queryParams: GuestReportRequest) {
    return this.http.get<GuestReport[]>(url + "analitics", { params: Utils.httpParams(queryParams) });
  }

  getGuestReportById(guestReportId: number) {
    return this.http.get<GuestReport>(url + "analitics/" + guestReportId);
  }

  getDataForChart(data: GuestReport[]) {
    data.forEach(el => {
      this.enter.push(el.entry)
      this.leave.push(el.leave)
      this.date.push((el.date.toString().split("T")[0]))
    })
  }

  refreshChart(data: GuestReport[]) {
    this.enter = [];
    this.leave = [];
    this.date = [];

    data.forEach(el => {
      this.enter.push(el.entry);
      this.leave.push(el.leave);
      this.date.push((el.date.toString().split("T")[0]));
    })
  }

  async loadChart(
    enterQuantity: number[],
    leaveQuantity: number[],
    date: string[],
  ) {
    this.chartOptions = {
      series: [
        {
          name: this.entires,
          data: enterQuantity
        },
        {
          name: this.exits,
          data: leaveQuantity
        },
      ],
      chart: {
        height: 250,
        type: "line",
        zoom: {
          enabled: true,
          type: 'x',  
          autoScaleYaxis: false,  
          zoomedArea: {
            fill: {
              color: '#90CAF9',
              opacity: 0.4
            },
            stroke: {
              color: '#0D47A1',
              opacity: 0.4,
              width: 1
            }
          }
        },
        defaultLocale: this.defaultLocale,
        locales: [ this.localePl, this.localeEn ],
        toolbar: {
          tools: {
            download: false,
          }
        },
      },
      colors: ["#D60D8C", "#4285F4"],
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 5,
        curve: "straight",
      },
      title: {
        text: this.chartHeader,
        align: "left",
        margin: 10,
        offsetX: 10,
        style: {
          fontSize: this.chartHeaderSize,
          fontWeight: 'bold',
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6
        }
      },
      xaxis: {
        type: 'category',
        tickPlacement: 'on',
        tickAmount: 6,
        labels: {
          datetimeUTC: true,
          datetimeFormatter: {
            year: 'yyyy',
            month: 'MMM \'yy',
            day: 'dd MMM',
          },
          trim: false,
        },
        categories: date
      },
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5
        }
      },
      noData: {
        text: this.noDataText,
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize: '18px',
        }
      }
    }
  }
}

